import React from "react";

const EventBubble = ({ x, y, text }) => (
  <g>
    <circle cx={x} cy={y - 30} r={14} fill="#ffef8a" stroke="#aaa" />
    <text x={x} y={y - 34} fontSize={10} textAnchor="middle" fill="#333">
      {text}
    </text>
  </g>
);

export default EventBubble;